import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { InboxModuleTypeInput } from '@libs/types/src/inbox/input-type/inbox-module-type.input';
import { InboxCountsObject } from '@libs/types/src/inbox/object-type/inbox-counts.object';

@Injectable({ providedIn: 'root' })
export class InboxCountsGqlService extends GqlServiceV2 {

    getCountsForDataboxes(input: InboxModuleTypeInput, frag: string): Promise<InboxCountsObject> {
        return this.query<InboxCountsObject>(
            `
                query($input: InboxModuleTypeInput!) {
                    databoxUnreadMessages {
                        getCountsForDataboxes(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    getCountsForDms(input: InboxModuleTypeInput, frag: string): Promise<InboxCountsObject> {
        return this.query<InboxCountsObject>(
            `
                query($input: InboxModuleTypeInput!) {
                    databoxUnreadMessages {
                        getCountsForDms(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    getCountsForEmailClient(input: InboxModuleTypeInput, frag: string): Promise<InboxCountsObject> {
        return this.query<InboxCountsObject>(
            `
                query($input: InboxModuleTypeInput!) {
                    databoxUnreadMessages {
                        getCountsForEmailClient(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
